document.addEventListener('click', function (event) {
  const link = event.target.closest('[data-whb-event]');
  if (!link) return;
  const properties = { placement: link.closest('header') ? 'header' : link.closest('footer') ? 'footer' : 'homepage', category: link.dataset.whbCategory || '' };
  if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
    Promise.resolve(window.Shopify.analytics.publish('wishhappybday:' + link.dataset.whbEvent, properties)).catch(function () {});
  }
});

(() => {
  const allowed = new Set(['gift_viewed', 'customization_started', 'photo_uploaded', 'design_approved', 'gift_add_requested', 'gift_added_to_cart']);
  const pendingKey = 'whb-pending-gift-add-v1';
  function previewMode() {
    const shopify = window.Shopify;
    return Boolean(shopify?.designMode || (shopify?.theme?.role && shopify.theme.role.toLowerCase() !== 'main'));
  }
  function clean(data) {
    const result = { schema_version: 1 };
    for (const key of ['product_id', 'variant_id', 'quantity', 'value']) {
      const value = Number(data[key]);
      if (data[key] != null && Number.isFinite(value) && value >= 0) result[key] = value;
    }
    for (const key of ['product_handle', 'product_type']) {
      if (typeof data[key] === 'string' && /^[a-zA-Z0-9_-]{1,100}$/.test(data[key])) result[key] = data[key];
    }
    if (/^[A-Z]{3}$/.test(data.currency || '')) result.currency = data.currency;
    return result;
  }
  function publish(name, data) {
    if (previewMode() || !allowed.has(name)) return;
    const metadata = clean(data);
    if (!metadata.product_id) return;
    try {
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        Promise.resolve(window.Shopify.analytics.publish('wishhappybday:' + name, metadata)).catch(() => {});
      }
    } catch {}
  }
  function canStoreAnalytics() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true; }
    catch { return false; }
  }
  document.addEventListener('whb:gift-event', event => {
    const data = event.detail || {};
    publish(data.name, data);
    if (data.name === 'gift_add_requested' && !previewMode() && canStoreAnalytics() && /^MC?[a-f0-9]{14}$/i.test(data.design_id || '')) {
      try { sessionStorage.setItem(pendingKey, JSON.stringify({ design_id: data.design_id, variant_id: data.variant_id, at: Date.now() })); } catch {}
    }
  });
  function confirmCartAddition() {
    if (previewMode() || !canStoreAnalytics()) return;
    try {
      const pending = JSON.parse(sessionStorage.getItem(pendingKey) || 'null');
      if (!pending) return;
      if (Date.now() - pending.at > 10 * 60 * 1000) { sessionStorage.removeItem(pendingKey); return; }
      const node = document.querySelector('[data-whb-cart-measurement]');
      if (!node) return;
      const line = JSON.parse(node.textContent).find(item => item.design_id === pending.design_id && String(item.variant_id) === String(pending.variant_id));
      if (line) { sessionStorage.removeItem(pendingKey); publish('gift_added_to_cart', line); }
    } catch {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', confirmCartAddition); else confirmCartAddition();
})();

